import { omitKeys } from 'lib/object/objectUtils'

export function slimifyGeo(geo: App.GeoState): Omit<App.GeoState, 'originAirports' | 'showTaxExclusivePrices' | 'airports' | 'initialised'> {
  return omitKeys(['originAirports', 'showTaxExclusivePrices', 'airports', 'initialised'], geo)
}
